module.exports = __webpack_public_path__ + "img/chevron-right.e37d7d13.svg";